import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import ExportButton from "@/components/ExportButton";
import DeleteButton from "@/components/DeleteButton";
import { useAuth } from "@/context/AuthContext";

export default function Attendance() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);

  const load = () => api.get("/attendance").then(r => setRows(r.data));
  useEffect(() => { load(); }, []);

  return (
    <div className="p-4 sm:p-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between">
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#6E6E6A]">Log</div>
            <h1 className="font-display text-4xl tracking-tighter font-black">Attendance</h1>
            <p className="text-[#6E6E6A] mt-2 text-sm">Workers check in/out from the worker app.</p>
          </div>
          <ExportButton module="attendance" />
        </div>

        <Card className="mt-8 border border-[#D8D8D5] shadow-none rounded-md overflow-hidden">
          <Table>
            <TableHeader><TableRow><TableHead>Date</TableHead><TableHead>Worker</TableHead><TableHead>Check-in</TableHead><TableHead>Check-out</TableHead><TableHead>Status</TableHead>{user?.role === "admin" && <TableHead></TableHead>}</TableRow></TableHeader>
            <TableBody>
              {rows.length === 0 && <TableRow><TableCell colSpan={user?.role === "admin" ? 6 : 5} className="text-center text-[#6E6E6A] py-8">No attendance records yet</TableCell></TableRow>}
              {rows.map(r => (
                <TableRow key={r.id}>
                  <TableCell>{r.date}</TableCell>
                  <TableCell>{r.worker_name}</TableCell>
                  <TableCell>{r.check_in || "—"}</TableCell>
                  <TableCell>{r.check_out || "—"}</TableCell>
                  <TableCell>
                    <Badge variant="outline" className={r.status === "present" ? "border-[#5B7B61]/40 text-[#5B7B61]" : "border-[#C85A42]/40 text-[#C85A42]"}>
                      {r.status}
                    </Badge>
                  </TableCell>
                  {user?.role === "admin" && (
                    <TableCell><DeleteButton endpoint={`/attendance/${r.id}`} label="attendance record" onDone={load} testid={`del-att-${r.id}`} /></TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      </div>
    </div>
  );
}
